import { forgetThumbnails } from '../shared/thumbnail-cache/thumbnail-cache'
import { isLaunchToken } from '../shared/jwt'

const ACCESS_TOKEN = 'accessToken'
const REFRESH_TOKEN = 'refreshToken'

// A bounded LMS session's token (client lms-launch, Phase F F-5) is the
// viewer's and the app's, never the admin's: it would read as a person's
// session with a learner's roles, and nothing here can refresh it. It is
// never stored (setAccessToken answers false), and one found in storage is
// removed with its refresh token and not used.
export const getAccessToken = () => {
  let token = sessionStorage.getItem(ACCESS_TOKEN)

  if (!token) {
    token = sessionStorage.getItem(ACCESS_TOKEN)
  }

  if (token && isLaunchToken(token)) {
    sessionStorage.removeItem(ACCESS_TOKEN)
    sessionStorage.removeItem(REFRESH_TOKEN)
    return null
  }

  return token
}

// Whether the token was stored: false for a bounded LMS session's, which
// leaves whatever was stored as it was.
export const setAccessToken = (accessToken, isSession) => {
  if (isLaunchToken(accessToken)) return false
  if (isSession) sessionStorage.setItem(ACCESS_TOKEN, accessToken)
  else sessionStorage.setItem(ACCESS_TOKEN, accessToken)
  return true
}

export const getRefreshToken = () => {
  let token = sessionStorage.getItem(REFRESH_TOKEN)

  if (!token) {
    token = sessionStorage.getItem(REFRESH_TOKEN)
  }

  return token
}

export const setRefreshToken = (refreshToken, isSession) => {
  if (isSession) sessionStorage.setItem(REFRESH_TOKEN, refreshToken)
  else sessionStorage.setItem(REFRESH_TOKEN, refreshToken)
}

// Every way a session ends (sign-out, a refused refresh, a 401) comes here.
// The organization's thumbnails this browser stored go too: a shared
// computer must not keep them for the next person (its flag is set before
// this returns, so a page that leaves at once still finishes the job).
export const removeTokens = isSession => {
  sessionStorage.removeItem(ACCESS_TOKEN)
  sessionStorage.removeItem(REFRESH_TOKEN)
  forgetThumbnails()
  // if (isSession) {
  //   sessionStorage.removeItem(ACCESS_TOKEN)
  //   sessionStorage.removeItem(REFRESH_TOKEN)
  // } else {
  //   sessionStorage.removeItem(ACCESS_TOKEN)
  //   sessionStorage.removeItem(REFRESH_TOKEN)
  // }
}
